import React from "react";

import { SamplingPlansContextProvider } from "./context/sampling-plans-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class SamplingPlansPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <SamplingPlansContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </SamplingPlansContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default SamplingPlansPage;
